<template>
    <span class="custom-icon">
        <md-icon v-if="!imageIcons[name]">{{ name }}</md-icon>
        <img v-if="!!imageIcons[name]" :src="'/imgs/icons/' + imageIcons[(active ? name + '_active' : name)]">
    </span>
</template>

<script>
    export default {
        data() {
            return {
                imageIcons: {
                    email: 'accueil-email.webp',
                    flight_takeoff: 'accueil-ville.webp',
                    flight_land: 'accueil-ville.webp',
                    person_outline: 'profil2.webp',
                    person_outline_active: 'profil1.webp',
                    business: 'entite2.webp',
                    business_active: 'entite1.webp',
                    payment: 'adhesion2.webp',
                    payment_active: 'adhesion1.webp',
                    rating_star_border: 'rating_star_border.svg',
                    rating_star: 'rating_star.svg',
                    rating_star_half: 'rating_star_half.svg',
                    rating_star_third: 'rating_star_third.svg',
                    rating_star_2third: 'rating_star_2third.svg',
                }
            }
        },
        props: {
            name: String,
            active: Boolean,
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/widgets/CustomIconComponent.vue